import "@fontsource/noto-sans-jp"

import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import { navigate } from "gatsby"

export const onRouteUpdate = ({ location }) => {
  // 1. リダイレクト処理
  if (location.pathname === "/recruit/picking_parttime/") {
    navigate("/", { replace: true });
    return;
  }

  // 2. ハッシュ（#）がない場合のみ、即座にトップへスクロール
  // これにより、遷移前の位置からTOPへ戻る「スクロールの挙動」が見えるのを防ぎます
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // アンカーリンク（例：/page/#contact）がある場合は、Gatsbyのデフォルト挙動に任せる
  if (location.hash) {
    return true;
  }

  // それ以外（通常の遷移）は、保存された位置を無視してトップ [0, 0] を返す
  return [0, 0];
};